import React from 'react';
import { Button } from '@mui/material';
import BaseModal from '../shared/components/base.modal';

interface ConfirmModalProps {
  open: boolean;
  handleNo: () => void;
  handleYes: () => void;
  handleOnClose: () => void;
  title?: string;
  message?: string;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open,
  handleNo,
  handleYes,
  handleOnClose,
  title = 'Подтверждение действия',
  message = 'Вы уверены, что хотите выполнить это действие?',
}) => {
  return (
    <BaseModal open={open} handleClose={handleOnClose}>
      <h2 className="fw-bold my-3">{title}</h2>
      <img alt="Logo" src="/logo120.svg" />
      <p className="my-5">{message}</p>
      <div className="d-flex justify-content-between my-3">
        <Button onClick={handleNo} variant="outlined" sx={{ mt: 2, width: '136px' }}>
          NO
        </Button>
        <Button onClick={handleYes} variant="contained" sx={{ mt: 2, width: '136px' }}>
          YES
        </Button>
      </div>
    </BaseModal>
  );
};

export default ConfirmModal;
